import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";

import NavBar from "../components/common/navBar";
import Footer from "../components/common/footer";
import Logo from "../components/common/logo";
import AboutBuilder from "../components/common/aboutBuilder";

import INFO from "../data/user";
import { getArticlesInSeries } from "../data/articles";

import "./styles/tools.css";

// Curated learning order for the governance path (not date order).
const PATH_ORDER = [
	"three-questions-before-you-deploy-ai",
	"nist-tevv-gap",
	"measuring-ai-principles",
	"policy-to-control-measuring-ai",
	"humane-in-the-loop",
	"the-accountability-split",
	"compliance-as-discipline",
	"owasp-agent-security-gap",
	"gcp-suspension-ai-security",
	"software-supply-chain-risk",
	"the-skill-changes-not-the-model",
	"guardrail-review-bathroom-lockout",
];

const ReadingPath = () => {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	const series = getArticlesInSeries("ai-governance-for-finserv-leaders");
	const ordered = PATH_ORDER.map((slug) =>
		series.find((a) => a.slug === slug)
	).filter(Boolean);

	return (
		<React.Fragment>
			<Helmet>
				<title>{`AI Governance for FinServ Leaders | ${INFO.main.title}`}</title>
				<meta
					name="description"
					content="A guided reading path on AI governance and security for financial services leaders: deployment discipline, the missing reviewer role, model risk, agent security, and supply chain risk."
				/>
			</Helmet>

			<div className="page-content">
				<NavBar active="articles" />
				<div className="content-wrapper">
					<div className="tools-logo-container">
						<div className="tools-logo">
							<Logo width={46} />
						</div>
					</div>

					<div className="tools-main-container">
						<div className="title tools-title">
							Start Here: AI Governance for FinServ Leaders
						</div>
						<div className="subtitle tools-subtitle">
							Six pieces in order, from the questions to ask before
							you deploy to the risks most teams miss. Read top to
							bottom, or jump to what you need.
						</div>

						<div className="path-list">
							{ordered.map((a, i) => (
								<Link
									className="path-step"
									to={`/article/${a.slug}`}
									key={a.slug}
								>
									<div className="path-step-num">
										{i + 1}
									</div>
									<div className="path-step-body">
										<div className="path-step-title">
											{a.title}
										</div>
										<div className="path-step-tldr">
											{a.tldr}
										</div>
										<div className="path-step-meta">
											{a.readingTime} min read
										</div>
									</div>
								</Link>
							))}
						</div>

						<AboutBuilder context="This path is the short version of what I have learned shipping AI in regulated finance, put in the order I wish I had read it." />
					</div>
					<div className="page-footer">
						<Footer />
					</div>
				</div>
			</div>
		</React.Fragment>
	);
};

export default ReadingPath;
